import type { LeaderboardEntry } from "./board";
import type { ConditionSafetyState } from "./safety-notes";
import { scoreOutOf100 } from "./score-display";
import { supProfileSafetyState } from "./sup-profile-safety";

export function namedSupLeaderboardSafetyState(
  entry: Pick<LeaderboardEntry, "safety">,
): ConditionSafetyState {
  if (entry.safety === null || entry.safety === undefined) return "no-data";
  return supProfileSafetyState(entry.safety);
}

export function namedSupLeaderboardDisplayLabel(
  entry: { conditionsLabel?: string | null },
): string {
  return entry.conditionsLabel ?? "Label unavailable";
}

export function namedSupLeaderboardScoreReading(
  entry:
    | Pick<LeaderboardEntry, "conditionsScore" | "conditionsLabel">
    | { score: number; conditionsLabel?: string | null },
): string {
  const score = "conditionsScore" in entry
    ? entry.conditionsScore
    : entry.score;
  return `${scoreOutOf100(score)}/100 · ${namedSupLeaderboardDisplayLabel(entry)}`;
}

export function isNamedSupLeaderboardPromotionEligible(
  entry: Pick<LeaderboardEntry, "safety">,
): boolean {
  return namedSupLeaderboardSafetyState(entry) !== "flagged-red";
}

export function namedSupPromotionEntries(
  entries: readonly LeaderboardEntry[],
  limit = 3,
): LeaderboardEntry[] {
  return entries
    .filter((entry) => !entry.isStale)
    .filter(isNamedSupLeaderboardPromotionEligible)
    .slice(0, limit);
}
